export const PRESCRIPTION_TASKS_ROUTE = '/prescription-tasks';
